module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2a"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/foreword"
    }
  }, [_vm._v("Foreword, by John Boessenecker")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter01"
    }
  }, [_vm._v("1. The First Murder Trial")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Too Late to Stay")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. A Debt Repaid")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. A Wild Horse Murder")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Brannan Bites a Bullet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. A Film Pioneer Who Packed a Pistol")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The Suicide that Wasn’t")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Winery Owner’s Train Tragedy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The Last Lynching")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. The Last Public Execution")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Bucking the System")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. A Cup of Joe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. The Belle of Chiles Valley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. A Solid Comfort Home Resort Murder?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. A Mine Murder")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. A Man Who Went Sour")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. A Wild Ride")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. A Town’s Innocence Lost")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. A Day at the Lake Turns Deadly")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. The Crime that Froze Time")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. The Oldest Profession")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. The Great Escapes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7b849f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 63
// module chunks = 0